module.exports = __webpack_public_path__ + "static/media/ep4.fd8d5fe9.jpg";